<template>
    <div class="row">
        <div class="col-12">
            <h3>{{ product.partname }}</h3>
            <p class="model"><small>{{ product.model }}</small></p>
        </div>
        <div class="col-12 col-lg-6">
            <table class="table table-sm">
                <tbody>
                    <tr>
                        <th scope="row">OEM Weight</th>
                        <td>{{ product.weight }}</td>
                    </tr>
                    <tr>
                        <th scope="row">CF Weight</th>
                        <td>{{ product.cf_weight }}</td>
                    </tr>
                    <tr>
                        <th scope="row">Weight reduction</th>
                        <td>{{ product.weight_reduction }}</td>
                    </tr>
                </tbody>
            </table>
            <img :src="variants[selected].surface_image" class="img-fluid" />
        </div>
        <div class="col-12 col-lg-6">
            <div class="row">
                <div class="col-12">
                    <div>
                        Order code:
                        <span class="text-danger">
                            {{ variants[selected].order_code }}
                        </span>
                    </div>
                    <p class="price" v-if="loggedin == 1">
                        <span class="full" v-if="variants[selected].price > variants[selected].discount_price">{{ variants[selected].price }}</span>
                        <span class="discount">{{ variants[selected].discount_price }} €<span v-if="loggedin != 1"> + VAT</span></span>
                    </p>
                    <div class="form-group">
                        <label for="lacquer">Material & Surface</label>
                        <select v-model="selected" class="form-control" id="lacquer">
                            <option v-for= "(item,index) in variants" :value="index">{{ item.material }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-12">
                    <div class="input-group my-1" v-if="loggedin == 1">
                        <input class="form-control" v-model="amount" type="number">
                        <div class="input-group-append">
                            <a class="btn btn-danger" v-on:click="addToCart(variants[selected])" href="#"><i class="fa fa-cart-plus"></i> ADD TO CART</a>
                        </div>
                    </div>
                    <!--<a class="btn btn-danger" v-if="loggedin == 1" v-on:click="addToWishlist(variants[selected])" :class="{btnSuccess: added}" href="#"><i class="fa fa-list"></i> ADD TO WISHLIST</a>-->
                    <a class="btn btn-danger mt-1" href="/where-to-buy"><i class="fa fa-motorcycle"></i> Where to buy</a>
                </div>
            </div>
        </div>
        <div class="col-12" v-if="product.note != ''">
            <p class="note">Notes: {{ product.note }}</p>
            <!--<p>Usually takes about <b>xy</b> minutes to make this part.</p>-->
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            selected: 0,
            amount: 1,
            added: false,
        }
    },
    props: {
        variants: Array,
        product: Array,
        price: String,
        loggedin: Number,
        selected: Number,
    },
    methods: {
        addToCart: function(item){
            // Item: {
            // '200923' => array(
            //       id: 2321,
            //       quantity' => '1',
            //       material' => '245T - Clear coat', // material in surface
            //       is_akcijski"  =>	1,  // Ali je akcijski 1 ali 0
            //       price'    =>   '99.6',
            //       note' => ''
            // }
            item.quantity = this.amount;
            var product = item;
            this.$store.dispatch('addToCart', product);
        },
        addToWishlist: function(item){
            // Submit changes to server for it to store in session
            window.axios.post('/api/add_cart/1', {
                order_code: item.order_code,
            }).then((response)=>{
                added = true;
            });
        },
    },
}
</script>
<style scoped lang="scss">
@import '~@/_variables.scss';

.price {
    color: $red;
    font-size: 2rem;
    text-align: right;
    .full {
        text-decoration: line-through;
        color: $darkgrey;
        font-size: 1.2rem;
        padding-bottom: 0.8rem;
    }
}
</style>
